import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StatePostParams } from "../types/posts/postParams";

interface PostsInitialStateParams {
    isLoading: boolean;
    getAllPosts: StatePostParams[];
    searchPost: StatePostParams[];
    currentPage: number;
    numberOfPages: number;
    totalNumber: number;
    singlePost: StatePostParams | null;
    updatePost: StatePostParams[] | null;
    deletePost: StatePostParams[] | null;
}

const initialState: PostsInitialStateParams = {
    isLoading: true,
    getAllPosts: [],
    searchPost: [],
    currentPage: 1,
    numberOfPages: 0,
    totalNumber: 0,
    singlePost: null,
    updatePost: null,
    deletePost: null,
}

const postsSlice = createSlice({
    name: 'POSTS',
    initialState,
    reducers: {
        startLoading: (state) => {
            state.isLoading     = true;
        },
        endLoading: (state) => {
            state.isLoading     = false;
        },
        setPosts: (state, action: PayloadAction<{
            data: StatePostParams[];
            currentPage: number;
            numberOfPages: number;
            totalNumber: number;
        }>) => {
            state.getAllPosts         = action.payload.data;
            state.currentPage         = action.payload.currentPage;
            state.numberOfPages       = action.payload.numberOfPages;
            state.totalNumber         = action.payload.totalNumber;
        },
        setSinglePost: (state, action: PayloadAction<StatePostParams>) => {
            state.singlePost       = action.payload;
        },
        setPostsSearch: (state, action: PayloadAction<{
            data: StatePostParams[];
            currentPage: number;
            numberOfPages: number;
            totalNumber: number;
        }>) => {
            state.searchPost      = action.payload.data;
            state.currentPage     = action.payload.currentPage;
            state.numberOfPages   = action.payload.numberOfPages;
            state.totalNumber     = action.payload.totalNumber;
        },
        setUpdatePost: (state, action: PayloadAction<StatePostParams>) => {
            state.updatePost      = state.getAllPosts.map((result) =>
                result._id === action.payload._id ? action.payload : result
            );
        },
        setDeletePost: (state, action: PayloadAction<string>) => {
            state.deletePost = state.getAllPosts.filter((result) => result._id !== action.payload);
        }
    }
})

export const { startLoading, endLoading, setPosts, setSinglePost, setPostsSearch, setUpdatePost, setDeletePost } = postsSlice.actions

export default postsSlice.reducer
